module.exports = __webpack_public_path__ + "img/04-lg.bd1146e.webp";